import React from 'react'
import './App.css'
import PhotoGallery from './PhotoGallery'

function App() {
  return (
    <div>
      <PhotoGallery />
    </div>
  )
}

export default App
